import { createQuery } from '@tanstack/solid-query'
import type { Product } from '~/lib/derive-extra-boxes'
import { api, getCurrentUserId } from '~/services/api'

type FullProduct = Product & {
  product_type?: string
  currency?: 'coin' | 'gem' | string
}

export const productsQueryKey = ['products'] as const

export const useProducts = () => {
  return createQuery(() => ({
    queryKey: productsQueryKey,
    queryFn: async () => {
      const userId = await getCurrentUserId()
      return await api.service
        .get(`store/users/${userId}/products`, {
          searchParams: { 'product_type[]': 'product' },
        })
        .json<FullProduct[]>()
    },
  }))
}
